import Http from "./../../utils/Http";
import { authLogout, authUser } from "./../../store/reducers/auth";
import { triggerUpdateGroups } from "./../../store/reducers/globalGroup";
import { notifyError } from "./../../utils/Helper";

const apiBase = "/api/v1/enterprise/";

/**
 * login user
 *
 * @param credentials
 * @returns {function(*)}
 */
export function login(credentials) {
  return Http.post("login", credentials);
}

export function verifyEmail(params) {
  return Http.post("verify-email", params);
}

/**
 * logout user
 *
 * @returns {function(*)}
 */
export function logout() {
  return (dispatch) => {
    dispatch(authLogout());
    // return Http.delete("auth/logout")
    //   .then(() => {
    //     dispatch(authLogout());
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };
}

export function fetchUser() {
  return (dispatch) => {
    return Http.get(apiBase + "general/auth/me")
      .then((res) => {
        const data = res.data.response;
        dispatch(authUser(data));
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          const { data } = err.response;
          notifyError(data.message);
          dispatch(authLogout());
        }
      });
  };
}

export function fetchGroups(params) {
  return (dispatch) => {
    return Http.post(apiBase + "general/user-groups", params)
      .then((res) => {
        const data = res.data.response;
        dispatch(triggerUpdateGroups(data));
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          const { data } = err.response;
          notifyError(data.message);
          dispatch(authLogout());
        }
      });
  };
}

export function updateProfile(params) {
  return Http.post(apiBase + "general/auth/updateprofile", params);
}

export function forgotPasswordEmail(params) {
  return Http.post("forgotpassword", params);
}

export function getMFADetails(params) {
  return Http.post(apiBase + "mfa/auth/get-details", params);
}

export function sendMFACode(params) {
  return Http.post(apiBase + "mfa/auth/send-code", params);
}

export function authCheckMFA(params) {
  return Http.post(apiBase + "mfa/auth/verify-code", params);
}

export function enterpriseAuthRefreshTokenRequest(params) {
  return Http.post(apiBase + "mfa/auth/refresh-token", params);
}

export function resetPassword(params) {
  return Http.post("resetpassword", params);
}

export function checkResetPasswordToken(params) {
  return Http.post("check-reset-token", params);
}

export function updateCompanyInfo(params) {
  return Http.post(apiBase + "general/auth/updatecompanyinfo", params);
}

export function changePassword(params) {
  return Http.post(apiBase + "general/auth/changepassword", params);
}

export function updateProfileImageRequest(params) {
  return Http.post(apiBase + "general/auth/updateprofileimage", params);
}

export function updateThemeSettings(params) {
  return Http.post(apiBase + "general/auth/updatethemesettings", params);
}

export function sendHelpMessage(params) {
  return Http.post(apiBase + "general/help-email", params);
}

export function demoVideoViewed() {
  return (dispatch) => {
    return Http.post(apiBase + "general/auth/demo-video-viewed")
      .then((res) => {
        const data = res.data.response;
        dispatch(authUser(data));
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          const { data } = err.response;
          notifyError(data.message);
          dispatch(authLogout());
        }
      });
  };
}

export function putSignedUrlS3(params) {
  return Http.post(
    apiBase + "general/put-signed-request-for-upload-to-s3",
    params
  );
}

export function putSignedUrlS3ForTask(params) {
  return Http.post(
    apiBase + "general/put-signed-request-for-upload-to-s3-task",
    params
  );
}

export function getEnterpriseDashboardData(params) {
  const queryParams = new URLSearchParams(params).toString();
  return Http.get(apiBase + "general/my-dashboard?" + queryParams);
}

export function getIVRDetails(params) {
  const queryParams = new URLSearchParams(params).toString();
  return Http.get(apiBase + "tasks/get-completed-ivr-task-details?" + queryParams);
}

export function getSoftSkillsDetails(params) {
  const queryParams = new URLSearchParams(params).toString();
  return Http.get(apiBase + "tasks/get-completed-soft-skills-task-details?" + queryParams);
}

export function getEnglishTestDetails(params) {
  const queryParams = new URLSearchParams(params).toString();
  return Http.get(apiBase + "tasks/get-completed-english-test-task-details?" + queryParams);
}

export function getCompletedTasksPendingReviewsList(params) {
  // console.log(">>> params ", params);
  let {
    url = apiBase + "tasks/get-completed-tasks-pending-review",
    searchInput = "",
    currentPage = 1,
    pageLimit = 10,
    sortBy = "name",
    sortType = "asc",
    selectedGroup = "",
    task_type = "all",
    status_filter = "all",
  } = params;
  if (searchInput != "") {
    currentPage = 1;
  }
  let _getParams = [];
  if (currentPage > 1) {
    _getParams.push(`currentPage=${currentPage}`);
  }
  _getParams.push(`limit=${pageLimit}`);
  _getParams.push(`sort_by=${sortBy}`);
  _getParams.push(`sort_type=${sortType}`);
  _getParams.push(`selected_group=${selectedGroup}`);
  _getParams.push(`task_type=${task_type}`);
  _getParams.push(`status_filter=${status_filter}`);
  if (searchInput != "") {
    _getParams.push(`searchInput=${encodeURIComponent(searchInput)}`);
  }
  url = url + "?" + _getParams.join("&");
  return Http.get(url);
}

export function addTaskFeedback(params) {
  return Http.post(apiBase + "tasks/add-task-feedback", params);
}

export function getCompletedEnglishTestsPendingReviewsList(params) {
  let {
    url = apiBase + "general/get-completed-english-tests",
    searchInput = "",
    currentPage = 1,
    pageLimit = 10,
    sortBy = "endedAt",
    sortType = "desc",
    selectedGroup = "",
    status_filter = "all",
    proficiency_level = "all"
  } = params;
  if (searchInput != "") {
    let currentPage = 1;
  }
  let _getParams = [];
  if (currentPage > 1) {
    _getParams.push(`currentPage=${currentPage}`);
  }
  _getParams.push(`limit=${pageLimit}`);
  _getParams.push(`sortBy=${sortBy}`);
  _getParams.push(`sortType=${sortType}`);
  _getParams.push(`selected_group=${selectedGroup}`);
  _getParams.push(`status_filter=${status_filter}`);
  _getParams.push(`proficiency_level=${proficiency_level}`);
  _getParams.push(`_t=${Date.now()}`); // Cache buster
  if (searchInput != "") {
    _getParams.push(`searchInput=${searchInput}`);
  }
  url = url + "?" + _getParams.join("&");
  return Http.get(url);
}

export function getCompletedSoftSkillsSessionsList(params) {
  let { 
    url = apiBase + "general/get-completed-soft-skills-sessions", 
    searchInput = "", 
    currentPage = 1, 
    pageLimit = 25, 
    sortBy = "endedAt", 
    sortType = "desc", 
    selectedGroup = "",
    status_filter = "all",
    mode = "all",
    difficulty = "all"
  } = params;
  let _getParams = [];
  if (currentPage > 1) {
    _getParams.push(`currentPage=${currentPage}`);
  }
  _getParams.push(`limit=${pageLimit}`);
  _getParams.push(`sortBy=${sortBy}`);
  _getParams.push(`sortType=${sortType}`);
  _getParams.push(`selected_group=${selectedGroup}`);
  _getParams.push(`status_filter=${status_filter}`);
  _getParams.push(`mode=${mode}`);
  _getParams.push(`difficulty=${difficulty}`);
  _getParams.push(`_t=${Date.now()}`); // Cache buster
  if (searchInput != "") {
    _getParams.push(`searchInput=${searchInput}`);
  }
  url = url + "?" + _getParams.join("&");
  return Http.get(url);
}

export function getCompletedCommunicationFlashcardsSessionsList(params) {
  let { 
    url = apiBase + "general/get-completed-flashcards-sessions", 
    searchInput = "", 
    currentPage = 1, 
    pageLimit = 25, 
    sortBy = "completedAt", 
    sortType = "desc", 
    selectedGroup = "",
    statusFilter = "all"
  } = params;
  let _getParams = [];
  if (currentPage > 1) {
    _getParams.push(`currentPage=${currentPage}`);
  }
  _getParams.push(`limit=${pageLimit}`);
  _getParams.push(`sortBy=${sortBy}`);
  _getParams.push(`sortType=${sortType}`);
  _getParams.push(`selected_group=${selectedGroup}`);
  _getParams.push(`status_filter=${statusFilter}`);
  _getParams.push(`_t=${Date.now()}`); // Cache buster
  if (searchInput != "") {
    _getParams.push(`searchInput=${searchInput}`);
  }
  url = url + "?" + _getParams.join("&");
  return Http.get(url);
}

export function getCompletedInterviewSessionsList(params) {
  let { 
    url = apiBase + "general/get-completed-interview-sessions", 
    searchInput = "", 
    currentPage = 1, 
    pageLimit = 25, 
    sortBy = "completedAt",  // Maps to createdAt in backend (when interview started)
    sortType = "desc", 
    selectedGroup = "",
    statusFilter = "all",
    duration = "all"
  } = params;
  let _getParams = [];
  if (currentPage > 1) {
    _getParams.push(`currentPage=${currentPage}`);
  }
  _getParams.push(`limit=${pageLimit}`);
  _getParams.push(`sortBy=${sortBy}`);
  _getParams.push(`sortType=${sortType}`);
  _getParams.push(`selected_group=${selectedGroup}`);
  _getParams.push(`status_filter=${statusFilter}`);
  _getParams.push(`duration=${duration}`);
  _getParams.push(`_t=${Date.now()}`); // Cache buster
  if (searchInput != "") {
    _getParams.push(`searchInput=${searchInput}`);
  }
  url = url + "?" + _getParams.join("&");
  return Http.get(url);
}

export function getInterviewSessionDetails(sessionId) {
  let url = apiBase + `general/get-interview-session-details?sessionId=${sessionId}&_t=${Date.now()}`;
  return Http.get(url);
}

export function getEnterpriseTasks(params) {
  let { url = apiBase + "tasks/get-enterprise-tasks", searchInput = "", currentPage = 1, pageLimit = 25, } = params;
  let _getParams = [];
  if (searchInput != "") {
    _getParams.push(`searchInput=${searchInput}`);
  }
  if (currentPage > 1) {
    _getParams.push(`currentPage=${currentPage}`);
  }
  _getParams.push(`limit=${pageLimit}`);
  url = url + "?" + _getParams.join("&");
  return Http.get(url);
}

export function assignTaskToFolder(params) {
  return Http.post(apiBase + "task-folders/assign-task-folder", params);
}